import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL_ALEXANDRIA

export default axios.create({
  baseURL: BASE_URL,
})
